import { Directive, HostListener } from '@angular/core'

@Directive()
export abstract class CanDeactivateDirective {
  //todo: add function/property to check whether form was touched/edited

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    $event.returnValue = true
  }
}
